import React from 'react';
import { AiOutlinePlus } from 'react-icons/ai';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/reducers';
import { TagState } from '../../../types/Tag';
import Community from '../../../types/community';
import tagService from '../../../services/community/tagService';
import CommunityTagButton from '../buttons/CommunityTagButton';

interface CommunityTagDisplayProps {
  community: Community;
  onTagsChanged: () => void;
}

export default function CommunityTagDisplay({ community, onTagsChanged }: CommunityTagDisplayProps): JSX.Element {
  const allTags = useSelector((state: RootState) => state.communityTags);
  const communityTagIds = community.tags ?? [];

  const assignedTags = allTags.filter((t: TagState) => communityTagIds.includes(Number(t.tagId)));

  const handleRemove = async (e: React.MouseEvent, tagId: string): Promise<void> => {
    e.stopPropagation();
    await tagService.removeTagFromCommunity(community.id, tagId);
    onTagsChanged();
  };

  return (
    <div className="flex-justify-center relative flex h-full w-full flex-wrap items-center gap-2">
      {assignedTags.slice(0, 2).map((tag) => (
        <div
          key={tag.tagId}
          className="group/tag content relative flex h-fit w-fit place-items-center items-center justify-center rounded-lg border border-primary-900 px-3 py-1 text-sm text-gray-600">
          <span className="font-medium">{tag.name}</span>
          <button
            type="button"
            onClick={(e) => handleRemove(e, tag.tagId)}
            className="absolute inset-y-0 right-1 ml-2 mt-[2px] rounded-lg bg-secondary-200 opacity-0 transition-all group-hover/tag:opacity-100">
            <AiOutlinePlus className="icon h-5 w-5 rotate-45 text-primary-900" />
          </button>
        </div>
      ))}
      <CommunityTagButton community={community} onTagsChanged={onTagsChanged}>
        <div className="group flex cursor-pointer items-center justify-center rounded-lg border-2 border-dashed border-primary px-1 py-1 hover:border-opacity-80 hover:bg-primary-300 hover:bg-opacity-20">
          <AiOutlinePlus className="h-4 w-4 text-primary group-hover:text-opacity-80" strokeWidth={2} />
          {assignedTags.length > 2 ? <span>{assignedTags.length - 2}</span> : null}
        </div>
      </CommunityTagButton>
    </div>
  );
}


